import React from "react";
import { Box } from "@mui/material";
import HomePopularTopics from "../layout/HomePopularTopics";
import { useI18n } from "../../../i18n/I18nContext";

export default function AllTopicsPage() {
    const { t } = useI18n();
    return (
        <Box sx={{ mt: -4, mb: -4 }}>
            <HomePopularTopics limit={0} showAllButton={false} title={t("home.popularTopics.allTitle")} />
        </Box>
    );
}
